import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react"

import Link from "@/common/components/Link"

type Props = {
  isOpen: boolean
  onClose: () => void
}

const DeprecatedSignInAsSafeModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent maxWidth={408} top={{ base: "unset", lg: "60px" }}>
        <ModalHeader
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          p={4}
          textStyle="h5"
        >
          Sign in as Safe
        </ModalHeader>
        <ModalBody p={4}>
          <Text>
            This flow is deprecated. Please disconnect your EOA and use
            WalletConnect to sign in as Safe as described in the{" "}
            <Link
              isExternal
              color="primary.500"
              fontWeight="medium"
              href="https://docs.tally.xyz/how-to-use-tally/use-tally-as-a-safe-multisig"
              target="_blank"
            >
              Tally docs
            </Link>
            .
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default DeprecatedSignInAsSafeModal
